import { z } from "zod";

const JoinHopSchema = z.object({
  fromColumn: z.string().min(1),
  toTable: z.string().min(1),
  toColumn: z.string().min(1),
});

const JoinDefinitionSchema = z.object({
  table: z.string().min(1),
  path: z.array(JoinHopSchema).min(1),
});

const ColumnDefinitionSchema = z.object({
  label: z.string().min(1),
  column: z.string().min(1),
  table: z.string().optional(),
});

export const ExportDefinitionSchema = z.object({
  id: z.number().positive().min(1),
  key: z.string().min(1).max(100),
  name: z.string().max(255),
  tableName: z.string().max(255),
  joins: z.array(JoinDefinitionSchema).default([]),
  columns: z.array(ColumnDefinitionSchema).min(1),
  scopeColumn: z.string().max(255).nullable().optional(),
  createdBy: z.number().positive().min(1),
  createdOn: z.date(),
  modifiedBy: z.number().positive().min(1),
  modifiedOn: z.date(),
  active: z.boolean(),
});

export type ExportDefinition = z.infer<typeof ExportDefinitionSchema>;
export type JoinDefinition = z.infer<typeof JoinDefinitionSchema>;
export type ColumnDefinition = z.infer<typeof ColumnDefinitionSchema>;